import { useTranslation } from 'react-i18next';
import styles from './WidgetStyles.module.css';

export function FooterDisclaimer() {
    const { t } = useTranslation();
    return (
        <footer className={styles.footerDisclaimer}>
            <small>
                {t('footerDisclaimer')}{' '}
                <a href="https://www.skf.com/group/footer/ai-terms-and-conditions" target="_blank" rel="noreferrer">
                    {t('footerTermsLabel')}
                </a>
                {' | '}
                <a href="https://www.skf.com/group/footer/privacy-policy" target="_blank" rel="noreferrer">
                    {t('footerPrivacyLabel')}
                </a>
            </small>
        </footer>
    );
}
